import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { VehiclesTableComponent } from "src/app/components/vehicles-table/vehicles-table.component";
import { HeaderComponent } from 'src/app/components/header/header.component';
import { RestrictionDialogComponent } from 'src/app/components/restriction-dialog/restriction-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { RestrictionsService } from 'src/app/services/restrictions.service';

@Component({
  selector: 'app-vehicles',
  imports: [VehiclesTableComponent, HeaderComponent, RestrictionDialogComponent, ButtonModule, AsyncPipe],
  templateUrl: './vehicles.component.html',
  styleUrl: './vehicles.component.scss'
})
export class VehiclesComponent {

  showDialog = false;
  isAdmin$ = this.userService.isAdmin$;

  constructor(private userService: UserService, private restrictionsService: RestrictionsService) {}

  handleSave(data: any) {
    this.restrictionsService.refreshRestrictions();
    this.showDialog = false;
  }

}
